import { createRouter, createWebHistory } from 'vue-router';
import DashboardPage from './views/DashboardPage.vue';
import LoginPage from './views/LoginPage.vue';
import HistoryPage from './views/HistoryPage.vue';
import HorarioPage from './views/HorarioPage.vue';
import CalendarioPagosConvenioPage from './views/CalendarioPagosConvenioPage.vue';
import CalendarioPagosColegiaturaPage from './views/CalendarioPagosColegiaturaPage.vue';
import CalificacionesBoletaPage from './views/CalificacionesBoletaPage.vue';
import HistorialPagosColegiaturaPage from './views/HistorialPagosColegiaturaPage.vue';
import HistorialPagosConvenioPage from './views/HistorialPagosConvenioPage.vue';
import PerfilPage from './views/PerfilPage.vue';
import ProspectosPage from './views/ProspectosPage.vue';
import HistorialProspectosPage from './views/HistorialProspectosPage.vue';
import TiendaPage from './views/TiendaPage.vue';
import AgregarSeguimientoPage from './views/AgregarSeguimientoPage.vue';
import DetalleProspectoPage from './views/DetalleProspectoPage.vue';
import HistorialSeguimientoPage from './views/HistorialSeguimientoPage.vue';
import IncidenciasPage from './views/IncidenciasPage.vue';
import DocumentosPage from './views/DocumentosPage.vue';
import PoliticaPrivacidadPage from './views/PoliticaPrivacidadPage.vue';
import TerminosServicioPage from './views/TerminosServicioPage.vue';
import NotFoundPage from './views/NotFoundPage.vue';
import InconformidadesPage from './views/InconformidadesPage.vue';
import FacturacionPage from './views/FacturacionPage.vue';
import BeneficiosPage from './views/BeneficiosPage.vue';
import FacturacionPagosPage from './views/FacturacionPagosPage.vue';
import NormatividadPage from './views/NormatividadPage.vue';
import ActividadesPage from './views/ActividadesPage.vue';
import ConstanciaPage from './views/ConstanciaPage.vue';
import CredencialPage from './views/CredencialPage.vue';
import axios from 'axios';

const routes = [
  {
    path: '/',
    redirect: '/login' // Redirigir al login
  },
  {
    path: '/inicio',
    name: 'Dashboard',
    component: DashboardPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage,
  },
  {
    path: '/history',
    name: 'History',
    component: HistoryPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/horario',
    name: 'Horario',
    component: HorarioPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/calendario-convenio',
    name: 'CalendarioPagosConvenio',
    component: CalendarioPagosConvenioPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/calendario-colegiaturas',
    name: 'CalendarioPagosColegiatura',
    component: CalendarioPagosColegiaturaPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/calificaciones-boleta',
    name: 'CalificacionesBoleta',
    component: CalificacionesBoletaPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/historial-colegiaturas',
    name: 'HistorialPagosColegiatura',
    component: HistorialPagosColegiaturaPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/historial-convenio',
    name: 'HistorialPagosConvenio',
    component: HistorialPagosConvenioPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/profile',
    name: 'Perfil',
    component: PerfilPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/prospectos',
    name: 'Prospectos',
    component: ProspectosPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/historial-prospectos',
    name: 'HistorialProspectos',
    component: HistorialProspectosPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/tienda',
    name: 'Tienda',
    component: TiendaPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/agregar-seguimiento/:prospectId',
    name: 'AgregarSeguimiento',
    component: AgregarSeguimientoPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/detalle-prospecto/:prospectId',
    name: 'DetalleProspecto',
    component: DetalleProspectoPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/historial-seguimiento/:prospectId',
    name: 'HistorialSeguimiento',
    component: HistorialSeguimientoPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/incidencias',
    name: 'Incidencias',
    component: IncidenciasPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/documentos',
    name: 'Documentos',
    component: DocumentosPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/politica-de-privacidad',
    name: 'PoliticaPrivacidad',
    component: PoliticaPrivacidadPage,
    meta: { requiresAuth: false },
  },
  {
    path: '/terminos-del-servicio',
    name: 'TerminosServicio',
    component: TerminosServicioPage,
    meta: { requiresAuth: false },
  },
  {
    path: '/inconformidades',
    name: 'Inconformidades',
    component: InconformidadesPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/mis-datos-facturacion',
    name: 'Facturacion',
    component: FacturacionPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/beneficios',
    name: 'Beneficios',
    component: BeneficiosPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/facturar-pagos',
    name: 'FacturarPagos',
    component: FacturacionPagosPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/normatividad',
    name: 'Normatividad',
    component: NormatividadPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/actividades',
    name: 'Actividades',
    component: ActividadesPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/constancia/:pathMatch(.*)*',
    name: 'Constancia',
    component: ConstanciaPage,
    meta: { requiresAuth: false }
  },
  {
    path: '/credenciales/:guid',
    name: 'Credencial',
    component: CredencialPage,
    meta: { requiresAuth: false }
  },
  //Siempre al final
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFoundPage,
    meta: { requiresAuth: false },
  }
  //Siempre al final
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Middleware para verificar autenticación antes de acceder a rutas protegidas
router.beforeEach(async (to, from, next) => {
    if (to.meta.requiresAuth) {
      try {
        const response = await axios.get('/me', { withCredentials: true }); // Verifica el token en la cookie
        if (response.data.user) {
          next();
        } else {
          next('/login');
        }
      } catch (error) {
        next('/login'); // Si hay error, ir al login
      }
    } else {
      next();
    }
  });

export default router;